import { ActionIcon, Autocomplete, Button, Card, ColorInput, ColorSwatch, Combobox, Fieldset, FileInput, Input, InputBase, Modal, MultiSelect, NumberInput, PasswordInput, Select, Switch, Text, TextInput, Textarea, Title, Tooltip, createTheme } from "@mantine/core";
import { DateInput, DatePickerInput, DateTimePicker, MonthPickerInput, TimeInput } from "@mantine/dates";

const defailtInputSize = 'md';
export const theme = createTheme({
  cursorType: 'default',
  fontFamily: 'Helvetica',
  components: {
    Fieldset: Fieldset.extend({
      defaultProps: {
        bg: 'none',
        style: { border: 'none' },
        p: 0,
        m: 0
      },
    }),
    Text: Text.extend({
      defaultProps: {
        size: defailtInputSize,
      },
    }),
    Card: Card.extend({
      defaultProps: {
        shadow: "md", radius: "md", withBorder: true, padding: "lg", my: 10
      },
    }),
    Button: Button.extend({
      defaultProps: {
        radius: 'md',
        color: "var(--mantine-color-washday-primary-9)"
      },
    }),
    ActionIcon: ActionIcon.extend({
      defaultProps: {
        radius: 'md',
        size: 'input-sm',
        color: "var(--mantine-color-washday-primary-9)",
      },
    }),
    Tooltip: Tooltip.extend({
      defaultProps: {
        multiline: true,
        withArrow: true,
        transitionProps: { duration: 200 }
      }
    }),
    Modal: Modal.extend({ //This affects confirmation modals too (ConfirmationModal component)
      defaultProps: {
        radius: 'lg',
        size: 'auto',
        centered: true
      }
    }),
    Switch: Switch.extend({
      defaultProps: {
        size: defailtInputSize,
      },
    }),
    Autocomplete: Autocomplete.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    FileInput: FileInput.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    TimeInput: TimeInput.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    ColorSwatch: ColorSwatch.extend({
      defaultProps: {
      },
    }),
    NumberInput: NumberInput.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    DateInput: DateInput.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    PasswordInput: PasswordInput.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    ColorInput: ColorInput.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md',
        swatchesPerRow: 9,
        closeOnColorSwatchClick: true,
        swatches: ['#2e2e2e', '#868e96', '#fa5252', '#e64980', '#be4bdb', '#7950f2', '#4c6ef5', '#228be6', '#15aabf', '#12b886', '#40c057', '#82c91e', '#fab005', '#fd7e14']
      },
    }),
    TextInput: TextInput.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    Input: Input.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    Textarea: Textarea.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    DateTimePicker: DateTimePicker.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    MonthPickerInput: MonthPickerInput.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    DatePickerInput: DatePickerInput.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    Select: Select.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    MultiSelect: MultiSelect.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
    InputBase: InputBase.extend({
      defaultProps: {
        size: defailtInputSize,
        radius: 'md'
      },
    }),
  },
  /* Put your mantine theme override here */
  colors: {
    'washday-primary': [
      "#ebf3ff",
      "#d4e3fa",
      "#a2c4f7",
      "#6fa4f6",
      "#4988f5",
      "#3576f5",
      "#2b6ef7",
      "#205ddc",
      "#1752c4",
      "#0047ad"
    ]
  },
  primaryColor: 'washday-primary',
  other: {
    washdaySecondaryColor: '#14a1e6',
    pagesBackGroundColor: 'rgb(240, 244, 248)',
    mainContentHeight: 'calc(100dvh - var(--app-shell-header-offset, 0rem) + var(--app-shell-padding) - (var(--app-shell-footer-offset, 0rem) + var(--app-shell-padding)))'
  }
});
